import 'choerodon-ui/lib/trigger/style';
